import { ReactComponent as ArrowRight } from 'assets/img/icons/chevron-right.svg';
import { ReactComponent as ArrowLeft } from 'assets/img/icons/chevron-left.svg';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const ExpandableButton = ({ green, children, isActive, onClick, withText }) => {
  const { t } = useTranslation();

  return withText ? (
    <>
      {isActive ? (
        <Button size="small" className="expandable" onClick={onClick}>
          {t('global.more')} <ArrowRight style={{ marginLeft: 8, transform: 'rotate(90deg)' }} />
        </Button>
      ) : (
        <Button size="small" className="expandable" onClick={onClick}>
          {t('global.more')} <ArrowLeft style={{ marginLeft: 8 }} />
        </Button>
      )}
      {children}
    </>
  ) : (
    <>
      <button className={`btn-expand ${green ? 'green' : ''}`} onClick={onClick}>
        {isActive ? (
          <ArrowRight style={{ marginRight: 8, transform: 'rotate(90deg)' }} />
        ) : (
          <ArrowRight style={{ marginRight: 8 }} />
        )}
        {children}
      </button>
    </>
  );
};

export default ExpandableButton;
